const mediaTypes = require('./mediaTypes'),
	bidders = require('./bidderService'),
	{getPubstackInformation} = require('./pubstackService');

function getAdUnit(config, slot) {
	if (typeof config.slots === 'undefined' || typeof config.slots[slot.name] === 'undefined') {
		return null;
	}

	const mt = mediaTypes.getMediaTypes(config, slot),
		bids = bidders.getBidders(config, slot),
		pubstackInformation = getPubstackInformation(slot);

	if (Object.keys(mt).length === 0 || bids.length === 0) {
		return null;
	}

	const adUnit = {
		'code': slot.domId,
		'mediaTypes': mt,
		bids
	};

	if (pubstackInformation) {
		adUnit.pubstack = pubstackInformation;
	}

	return adUnit;
}

module.exports = {
	getAdUnit
};
